import { useInstantSearch } from 'react-instantsearch';
import { useFormikContext } from 'formik';
import {
  ClientSearchAutofillValues,
  applyHitToForm,
} from '../../utils/form/clientValues';

// The full sequence for picking a client out of the algolia results: stage the
// values, resync the index state, then validate once. Shared so the classic and
// redesigned result rows can't drift apart.
function useApplyClientHit(namePrefix: string[]) {
  const { setIndexUiState, refresh } = useInstantSearch();
  const { setFieldValue, validateForm } =
    useFormikContext<ClientSearchAutofillValues>();

  return (hit: any) => {
    applyHitToForm(hit, namePrefix, setFieldValue);

    // Refresh the algolia cache so new record will show up
    refresh();

    setIndexUiState(prevIndexUiState => ({
      ...prevIndexUiState,
      query: hit.fullName,
    }));

    setTimeout(() => validateForm(), 0);
  };
}

export default useApplyClientHit;
